import * as types from '../types.js';

export default {

	html: `
		<style>
			#sm-reason #reason { width: 28rem; }
		</style>
		<form id="sm-reason" class="form" autocomplete="off">
			<div class="title">Motivo da operação</div>
			<div class="fsb mtl">
				<label>Natureza
					<input id="movement_kind" type="text" list="movement_kind_list">
				</label>
				<label>Motivo<sup>*</sup>
					<input id="reason" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Confirmar</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#sm-reason',
		init(formset) {
			formset.form.eraseValues();
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#movement_kind' }, types: [ types.opt_movement_kind(), types.datalist() ] },
		{ properties: { selector: '#reason' }, types: [] },
	],
};
